import { useTranslation } from 'react-i18next';
import { mockComments } from '@/mocks/articles';

export default function CommentSection() {
  const { t } = useTranslation();
  const comments = mockComments.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-accent-50/50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs text-accent-700 font-medium tracking-wide uppercase">
              {t('home_comments_label')}
            </span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            {t('home_comments_title1')}
            <br />
            {t('home_comments_title2')}
          </h2>
          <p className="text-sm text-foreground-600 mt-3">{t('home_comments_subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((c, idx) => (
            <div
              key={c.id}
              className={`bg-background-50 rounded-2xl p-5 transition-all duration-300 hover:scale-[1.02] ${
                idx === 5 ? 'opacity-60' : ''
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span key={star} className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill text-accent-500 text-sm"></i>
                  </span>
                ))}
              </div>
              <p className="text-sm font-medium text-foreground-900 mb-2 line-clamp-2">
                {c.comment}
              </p>
              <p className="text-xs text-foreground-600 line-clamp-3 mb-4 leading-relaxed">
                {c.comment}
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={c.avatar}
                  alt={c.username}
                  className="w-9 h-9 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-medium text-foreground-950">{c.username}</p>
                  <p className="text-xs text-foreground-500">{c.level}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}